export const connect = {
  pracAvatarAlt: "Avatar for {{pracName}}",
  header: {
    productName: "Connect",
    beta: "Beta",
  },
  pageHead: {
    backToProfile: "Back to profile",
    eyebrow: "Almost there",
    title: "Create your account",
  },
  form: {
    additionalInformation: "Any additional information for your practitioner? (optional)",
    alreadyHaveAnAccount: "Already have an account?",
  },
  practitionerCard: {
    requestingAppointmentWith: "Requesting an appointment with",
    typeAndLocation: "{{practitionerType}} · {{location}}",
    firstVisit: "First visit",
    subsequentVisit: "Subsequent visit",
    placeholderFirstVisitPrice: "Free 15 min meet and greet",
    placeholderSubsequentVisitPrice: "$185 - 230",
  },
  nextSteps: {
    title: "What happens next",
    selectTimeslot: "Select a timeslot on {{pracFirstName}}'s agenda",
    requestGoesToOffice: "Your request and note go straight to {{pracFirstName}}'s office.",
    accountUnlocksStorefront:
      "Meanwhile, your account unlocks {{pracFirstName}}'s storefront of professional-grade supplements.",
  },
} as const;
